import { Discount } from "./Discount";
import { DiscountTarget, DiscountType } from "./RawCost";


export class SelfTrainingDiscount extends Discount
{
    constructor()
    {
        super({
            Target: DiscountTarget.RentalItems,
            Type: DiscountType.LimitedPercent,
            Name: "samodzielne szkolenie",
            Code: "self-training",
            Value: 10,
            IsVisible: true,
            Limit: 50
        });
    }
}
